import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Image,
} from '@chakra-ui/react';
import Content from '@components/content';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function MarketCouponEventDrawer() {
  const [opacity, setOpacity] = useState(1);
  const [visible, setVisible] = useState(false);
  const imageRef = useRef(null);
  const { t } = useTranslation('event');

  useEffect(() => {
    const timer = setTimeout(() => {
      if (imageRef.current) {
        setOpacity(0);
      }
    }, 3000);

    const timer2 = setTimeout(() => {
      if (imageRef.current) {
        setVisible(true);
      }
    }, 2300);
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <DrawerContent className="rounded-t-3xl">
      <DrawerHeader className="flex items-center justify-center">
        <div className="font-bold w-full flex items-center justify-center flex-col italic">
          <p>Panther Mall</p>
          <p>Grand Open</p>
        </div>
      </DrawerHeader>
      <DrawerCloseButton />
      <DrawerBody>
        <Content className="w-full px-0">
          <div ref={imageRef} className="relative mb-8">
            <Image
              src="/static/images/gift.gif"
              className="gift-box"
              style={{
                opacity: opacity,
                transition: 'opacity 0.5s ease-in-out',
              }}
            />
            <Image
              src="/static/images/panthermall-coupon.png"
              className="absolute top-0 left-0 w-full h-[150px] max-h-[150px]"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible
                  ? 'translateY(0)'
                  : 'translateY(calc(100vh + 50px))',
                transition:
                  'opacity 1.4s ease-in-out, transform 1.4s ease-in-out',
              }}
            />
            <div
              className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full"
              style={{
                opacity: visible ? 1 : 0,
                transition: 'opacity 4s ease-in-out',
              }}
            >
              <div className="w-full flex items-center justify-center">
                <p className="font-bold text-md text-primary-700 mb-2 w-full text-center">
                  {t('message5')}
                </p>
              </div>
              <p className="text-xs text-zinc-400 ">* {t('message4')}</p>
              <p className="text-xs text-zinc-400 ">* {t('message1')}</p>
              <p className="text-xs text-zinc-400 ">* {t('message2')}</p>
              <p className="text-xs text-zinc-400 ">* {t('message3')}</p>
            </div>
          </div>
        </Content>
      </DrawerBody>
    </DrawerContent>
  );
}
